<template>
  <div v-if="!loading">
    <form>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title>
              Priebeh hodnotení
            </v-card-title>
            <v-card-text>
              <div v-if="form.cra_graph.length > 0">
                <apexchart
                  type="line"
                  height="350"
                  :options="chartOptions"
                  :series="graphData"
                />
              </div>
              <div v-else>
                Hodnotenia nie sú k dispozícií
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>Probačný a ochranný dohľad</v-card-title>
            <v-card-text>
              <v-textarea
                v-model="form.probacny_a_ochranny_dohlad_popis"
                auto-grow
                rows="1"
                name="Textový popis"
                label="Textový popis"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <v-btn
          class="ma-2"
          fixed
          right
          bottom
          dark
          rounded
          color="primary"
          @click="updateItem()"
        >
          Uložiť
        </v-btn>
        <div class="flex-grow-1" />
      </v-layout>
    </form>

    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>
  </div>

  <div v-else>
    <form-skeleton-component skeleton_type="RizikaADohlad" />
  </div>
</template>

<script>
import Vue from "vue";
import { APIService } from "@/http/APIService.js";
import VeeValidate, { Validator } from "vee-validate";
import sk from "vee-validate/dist/locale/sk";
import FormSkeleton from "../components/FormSkeleton.vue";
import VueApexCharts from 'vue-apexcharts'

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

Vue.use(VeeValidate);
Validator.localize("sk", sk);

const apiService = new APIService();

export default {
  $_veeValidate: {
    validator: "new",
  },

  components: {
    "form-skeleton-component": FormSkeleton,
  },

  data: () => ({
    loading: false,
    snackbar_saved: false,
    snackbar_error: false,

    form: {
      id: null,
      probacny_a_ochranny_dohlad_popis: "",
      cra_graph: []
    },

    selects: {
      nepravdive_zavadzajuce: [
        "podľa výsledkov náhodného overenia vybraných informácii poskytovaných odsúdeným odsúdený UVIEDOL nepravdivé/zavádzajúce informácie pri hodnotení, vo vstupnom dotazníku a pri pohovoroch",
        "podľa výsledkov náhodného overenia vybraných informácii poskytovaných odsúdeným odsúdený NEUVIEDOL nepravdivé/zavádzajúce informácie pri hodnotení, vo vstupnom dotazníku a pri pohovoroch",
      ],
    },

    manual: {
      nepravdive_zavadzajuce: {
        nazov: "Nepravdivé/zavádzajúce informácie",
        priklad: [],
        poznamka: [],
        zdroj: [],
        charakteristika: [
          "Ak ktorýkoľvek z hodnotiteľov zistí akýkoľvek rozpor (napr. klamstvo, zavádzanie...) v údajoch poskytnutých odsúdeným,  túto skutočnosť oznámi prípadovému manažérovi.",
        ],
      },
    },
  }),

  computed: {
    graphData: function () {
      var series = this.form.cra_graph.map(function (element) {
        return [new Date(element.created_at).getTime(), element.score];
      });

      return [{ name: "CRA", data: series }]
    },

    chartOptions: function () {
      var vm = this;
      return {
        chart: {
          height: 200,
          type: 'area',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: 'straight'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5
          },
        },
        xaxis: {
          type: "datetime",
          labels: {
            format: "dd/MM/yy"
          }
        },
        yaxis: {
          min: 0,
          max: 115
        },

        tooltip: {
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            return '<div class="ma-2"><div>' +
              '<span>' + 'Typ: CRA-' + vm.form.cra_graph[dataPointIndex].type + '</span>' +
              '</div>' +
              '<div>' +
              '<span>' + 'Verzia: ' + vm.form.cra_graph[dataPointIndex].version + '</span>' +
              '</div>' +
              '<div>' +
              '<span>' + 'Percento: ' + vm.form.cra_graph[dataPointIndex].percentage + '% </span>' +
              '</div>' +
              '<div>' +
              '<span>' + 'Riziko: ' + vm.form.cra_graph[dataPointIndex].string_score + '</span>' +
              '</div>' +
              '<div>' +
              '<span>' + 'Dôvod: ' + vm.form.cra_graph[dataPointIndex].comment + '</span>' +
              '</div>' +
              '<div>' +
              '<span>' + 'Ústav: ' + vm.form.cra_graph[dataPointIndex].institution_full.name + '</span>' +
              '</div></div>'
          }
        },

        annotations: {
          yaxis: [
            {
              y: 0,
              y2: 25,
              borderColor: 'green',
              fillColor: 'green',
              opacity: 0.1,
              label: {
                borderColor: '#333',
                style: {
                  fontSize: '10px',
                  color: 'white',
                  background: 'green',
                },
                text: 'Nízke riziko',
              }
            },

            {
              y: 25,
              y2: 49,
              borderColor: 'orange',
              fillColor: 'orange',
              opacity: 0.1,
              label: {
                borderColor: '#333',
                style: {
                  fontSize: '10px',
                  color: 'white',
                  background: 'orange',
                },
                text: 'Stredné riziko',
              }
            },

            {
              y: 49,
              y2: 115,
              borderColor: 'red',
              fillColor: 'red',
              opacity: 0.1,
              label: {
                textAnchor: "left",
                borderColor: '#333',
                position: "left",
                style: {
                  fontSize: '10px',
                  color: 'white',
                  background: 'red',
                },
                text: 'Vysoké riziko',
              }
            },
          ],

          xaxis: [{
            x: new Date('01 Oct 2019').getTime(),
            borderColor: '#999',
            yAxisIndex: 0,
            label: {
              show: true,
              text: 'Začiatok pilotnej prevádzky',
              style: {
                color: "#fff",
                background: 'orange'
              }
            }
          },
          {
            x: new Date('31 Jan 2020').getTime(),
            borderColor: '#999',
            yAxisIndex: 0,
            label: {
              show: true,
              text: 'Koniec pilotnej prevádzky',
              style: {
                color: "#fff",
                background: "orange"
              }
            }
          },
          {
            x: new Date('01 Jan 2021').getTime(),
            borderColor: '#999',
            yAxisIndex: 0,
            label: {
              show: true,
              text: 'Začiatok ostrej prevádzky',
              style: {
                color: "#fff",
                background: 'green'
              }
            }
          }]
        }

      }
    },

  },

  created() {
    this.getItem();
  },

  methods: {
    getItem() {
      this.loading = true;
      apiService
        .getIapszRizikaADohlad(this.$route.params.id)
        .then((response) => {
          this.form = response;
          this.loading = false;
        });
    },

    updateItem() {
      apiService
        .updateIapszRizikaADohlad(this.form, this.$route.params.id)
        .then(
          (response) => {
            this.snackbar_saved = true;
            this.form = response;
          },
          () => {
            this.snackbar_error = true;
          }
        );
    },
  },
};
</script>